import Vue from 'vue';
import Router from 'vue-router';
import MainLoader from "@/views/loader/MainLoader";
import ConditionsLoader from "@/views/loader/ConditionsLoader";
import NewPrivacyLoader from "@/views/loader/NewPrivacyLoader";
import TermsLoader from "@/views/loader/TermsLoader";


Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '',
            component: MainLoader,
        },
        {
            path: '/privacy',
            component: NewPrivacyLoader,
        },
        {
            path: '/imprint',
            component: ConditionsLoader,
        },
        {
            path: '/terms',
            component: TermsLoader,
        },
        {
            path: '*',
            redirect: '/',
        }
    ],
});
